export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// /home/ig_comp_doc/sandbox-manager-v3/node_modules/react-transition-group/esm/config.js
// module id = 434
// module chunks = 0